import undoAble, { excludeAction, ActionTypes } from 'redux-undo'
import {
  DEVICE_ORIENTATION,
  EHS_DESIGN_STATUS
} from 'constants/EnterpriseHomeScreenDesignerConstant'

import {
  SET_META_DATA,
  NEXT_STEP,
  PREVIOUS_STEP,
  RESET,
  SET_ROLES_DATA,
  ADD_ROLES_DATA,
  SET_EDITOR_MODE,
  SET_SCREEN_SIZE,
  SET_ID,
  RESET_STEP,
  SET_IS_EDITOR_MODE,
} from 'redux/constants/HomeScreenDesigner'
import { ehsScreenSize } from 'views/app-views/enterprise-home-screen-builder/utils/deviceScreenSizeCollection'
import { cloneDeep, merge } from 'lodash'

const LIMIT_UNDO_REDO = 11

const initState = () => ({
  isEditorMode: false,
  roleCurrentIndex: 0,
  homeScreen: {
    devicePreview: {
      statusBar: true,
      systemBar: true,
    },
    profileId: null,
    metaData: {
      category: 2,
      name: undefined,
      description: '',
      deviceType: 'mobile',
      deviceSubType: '',
      orientation: DEVICE_ORIENTATION.PORTRAIT,
      profileType: undefined,
      type: 'ehsConfigurator',
      status: EHS_DESIGN_STATUS.DRAFT,
      userId: '',
      roleCreationType: undefined,
    },
    screen: ehsScreenSize.mobile,
    roles: {}, // use object instead of an array to make the data retrival faster
  },
})

const enterpriseHomeScreenDesigner = (state = initState(), action) => {
  switch (action.type) {
    
    case RESET: {
      return initState()
    }

    case SET_META_DATA: 
      return cloneDeep({ 
          ...state,
          homeScreen: {
            ...state.homeScreen,
            metaData: {
              ...state.homeScreen.metaData,
              ...action.payload,
            },
          },
    })

    case SET_ROLES_DATA:
      return cloneDeep({
        ...state,
        homeScreen: {
          ...state.homeScreen,
          roles: action.payload,
        }
      })

    case ADD_ROLES_DATA:
      return cloneDeep({
        ...state,
        homeScreen: {
          ...state.homeScreen,
          roles: {
            ...state.homeScreen.roles,
            ...action.payload,
          },
        }
      })

    case SET_EDITOR_MODE: {
      return {
        ...state,
        isEditorMode: action?.payload || false,
      }
    }
    
    case SET_SCREEN_SIZE:
          return cloneDeep({
            ...state,
            homeScreen: {
              ...state.homeScreen,
              screen: {
                ...state.homeScreen.screen,
                ...action.payload,
              },
            },
          })

    case NEXT_STEP: {
      return {
        ...state,
        wizardStep: state.wizardStep + 1,
      }
    }

    case PREVIOUS_STEP: {
      return {
        ...state,
        wizardStep: state.wizardStep - 1,
      }
    }

    case RESET_STEP: {
      return {
        ...state,
        wizardStep: 0,
      }
    }

    default:
      return state
  }
}

const RemoveUndoAble = [
  RESET_STEP,
  SET_ID,
  PREVIOUS_STEP,
  NEXT_STEP,
  SET_IS_EDITOR_MODE,
]

// 
const undoAbleEnterpriseHomescreenDesigner = undoAble(enterpriseHomeScreenDesigner, {
  limit: LIMIT_UNDO_REDO,
  syncFilter: true,
  clearHistoryType: ActionTypes.CLEAR_HISTORY,
  filter: excludeAction(RemoveUndoAble),
})
export default undoAbleEnterpriseHomescreenDesigner
